import { useController } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TextField } from '../../legacy-form-fields'
import { BrivoConnectionFormValues } from './brivo.schema'

const useTextFieldProps = (name: keyof BrivoConnectionFormValues) => {
  const { field, fieldState } = useController<BrivoConnectionFormValues>({ name })
  return {
    errorLabel: fieldState.error?.message,
    isError: Boolean(fieldState.error),
    name: field.name,
    onBlur: field.onBlur,
    onChange: field.onChange,
    value: field.value ?? '',
  }
}

export const BrivoFields = () => {
  const { t } = useTranslation(['organisation'])
  const clientId = useTextFieldProps('clientId')
  const clientSecret = useTextFieldProps('clientSecret')
  const sdkClientId = useTextFieldProps('sdkClientId')
  const sdkClientSecret = useTextFieldProps('sdkClientSecret')
  const apiKey = useTextFieldProps('apiKey')
  const username = useTextFieldProps('username')
  const password = useTextFieldProps('password')

  return (
    <div className="integration-configuration">
      <TextField
        {...clientId}
        label={t('organisation:places.integrations.brivo.fields.clientId.label')}
        placeholder={t('organisation:places.integrations.brivo.fields.clientId.placeholder')}
      />
      <TextField
        {...clientSecret}
        label={t('organisation:places.integrations.brivo.fields.clientSecret.label')}
        placeholder={t('organisation:places.integrations.brivo.fields.clientSecret.placeholder')}
        type="password"
      />
      <TextField
        {...sdkClientId}
        label={t('organisation:places.integrations.brivo.fields.sdkClientId.label')}
        placeholder={t('organisation:places.integrations.brivo.fields.sdkClientId.placeholder')}
      />
      <TextField
        {...sdkClientSecret}
        label={t('organisation:places.integrations.brivo.fields.sdkClientSecret.label')}
        placeholder={t('organisation:places.integrations.brivo.fields.sdkClientSecret.placeholder')}
        type="password"
      />
      <TextField
        {...apiKey}
        label={t('organisation:places.integrations.brivo.fields.apiKey.label')}
        placeholder={t('organisation:places.integrations.brivo.fields.apiKey.placeholder')}
        type="password"
      />
      <TextField
        {...username}
        label={t('organisation:places.integrations.brivo.fields.username.label')}
        placeholder={t('organisation:places.integrations.brivo.fields.username.placeholder')}
      />
      <TextField
        {...password}
        label={t('organisation:places.integrations.brivo.fields.password.label')}
        placeholder={t('organisation:places.integrations.brivo.fields.password.placeholder')}
        type="password"
      />
    </div>
  )
}
